import { useState, useEffect, FC } from "react";
import { SelectInterface } from "types/other/TypeOthers";

const Select :FC<SelectInterface>= ({enlabel,label,options,active,openModalSuccess}) => {

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [activeName, setActiveName] = useState<string>('');
  const [showOptions, setShowOptions] = useState<boolean>(false);

  useEffect(() => {
    if (active) {
      const obj:any=options.find(element=>element?.name===active)?.key;
      setActiveIndex(obj);
      setActiveName(active);
    }
  }, []);

  const openOptions = () => {
    setShowOptions(!showOptions);
  };
  const chooseOption = (name:string,index: number) => {
    setShowOptions(false);
    setActiveIndex(index);
    setActiveName(name)
  };
  useEffect(() => {
    if (openModalSuccess) {
        localStorage.setItem(enlabel,activeName);
    }
  }, [activeName, enlabel, openModalSuccess]);
  return (
 
        <>
       <div
              onClick={openOptions}
              className="containerInpuSettingsMap pointer"
            >
              <div className="lableAbsoluteOption">
                {label}
              </div>
              <div className="inpTitleSettingMap">
                {options[activeIndex]?.name}
              </div>
              <div className="icon3-chevron-down" />
            </div>
            {showOptions ? (
              <div className="containerOptionsAbsolute pointer scrollbar-div">
                {options.map((op, index) => (
                  <div
                    onClick={() => chooseOption(op?.name,index)}
                    className={
                      index === activeIndex
                        ? "optionsContentDiff"
                        : "optionsContent"
                    }
                    key={op.key}
                  >
                    <div className="optionsTitle">{op?.name}</div>
                  </div>
                ))}
              </div>
            ) : null}
          </>
  );
};
export default Select;
